module.exports = __webpack_public_path__ + "static/media/translumina.97499282.svg";